module.exports = __webpack_public_path__ + "static/assets/img/emma.ad0bdc33.jpg";